import { Slide } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import {
  EXTRA_AUDIENCES_COUNT,
  TOP_AUDIENCES_COUNT,
  TextsOptions,
  texts,
} from './audience-profile/texts';
import { shapes } from './audience-profile/shapes';
import { filterByPredictiveGroup } from '@features/lci-report';
import { truncateAudienceGroupNames } from '@features/campaign-analytics';
import { sortBy } from '@utils/arrays';

type AudienceProfileSlideOptions = {
  audienceProfile: CampaignAnalyticsReport['audienceProfile'];
};

export const audienceProfilePairsByGroup = (
  audienceProfile: CampaignAnalyticsReport['audienceProfile']
): TextsOptions['nameValuePairsByGroup'] => {
  const sortedVisited = audienceProfile.data.visited.toSorted(
    sortBy('value', 'desc')
  );
  const defaultVisitedData = filterByPredictiveGroup(sortedVisited);

  const topData = defaultVisitedData.slice(0, TOP_AUDIENCES_COUNT);
  const extraData = defaultVisitedData.slice(
    TOP_AUDIENCES_COUNT,
    TOP_AUDIENCES_COUNT + EXTRA_AUDIENCES_COUNT
  );

  const truncatedTopData = truncateAudienceGroupNames(topData);
  const truncatedExtraData = truncateAudienceGroupNames(extraData);

  return {
    top: truncatedTopData,
    extra: truncatedExtraData,
  };
};

export const audienceProfileSlide = (
  options: AudienceProfileSlideOptions
): Slide => {
  const nameValuePairsByGroup = audienceProfilePairsByGroup(
    options.audienceProfile
  );
  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: texts({ nameValuePairsByGroup }),
    shapes: shapes({ nameValuePairsByGroup }),
  };
};
